<template>
  <v-card class="validateEmailCard">
    <v-card-text class="validateEmailCard__information">
      <CSSVGIcon
        iconName="email-action-disable"
        classes="validateEmailCard__emailValidationIcon icon--red"
      />

      <div>
        <h4 class="validateEmailCard__title">
          {{ translate('HEADLINE_MYCAREGIVERS_EMAILVALIDATE') }}
        </h4>

        <p>{{ translate('TEXT_MYCAREGIVERS_EMAILVALIDATE') }}</p>

        <CSButton
          color="slate100"
          :loading="submitLoading"
          :text="translate('BUTTON_RESEND_EMAIL_VERIFICATION')"
          id="button_email_verfication_resend"
          :round="false"
          :onClick="resendEmailVerification"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'
import { eventBus } from '@/main'
import { resendEmailVerification } from '@/sdk/clients/UserClient'

export default {
  name: 'CSValidateEmailCard',
  components: {
    CSButton,
    CSSVGIcon,
  },

  data() {
    return {
      submitLoading: false,
    }
  },

  methods: {
    async resendEmailVerification() {
      this.submitLoading = true

      const resendEmail = await resendEmailVerification()

      this.submitLoading = false

      if (resendEmail) {
        eventBus.$emit(
          'showSnackbarMessage',
          this.translate('SNACKBAR_RESEND_EMAIL_VERIFICATION_STATUS_VALID'),
        )
      } else {
        eventBus.$emit(
          'showSnackbarMessage',
          this.translate('SNACKBAR_RESEND_EMAIL_VERIFICATION_STATUS_INVALID'),
          { color: 'error' },
        )
      }

      this.$gtm.trackEvent({
        category: 'registration',
        action: 'user triggered new email confirmation email',
        label: '/kunde/meine-alltagshelfer',
      })
    },
  },
}
</script>
